import { Injectable } from "@angular/core";

@Injectable({
    'providedIn': 'root'
})
export class CreateSlugService {

    createSlug(slug: string) {
        return slug.toLocaleLowerCase()
            .replace(/[áäàâã]/g, 'a')
            .replace(/[éëèê]/g, 'e')
            .replace(/[íïìî]/g, 'i')
            .replace(/[óöòôõ]/g, 'o')
            .replace(/[úüùû]/g, 'u')
            .replace(/ñ/g, 'n')
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    }
}
